/**
 * Mappa ruoli mantra → classi colore Tailwind.
 *
 * Andrea 2026-05-22: ALLINEATA alla palette FantaSquad centralizzata
 * in `ruoliColors.ts`. Stessi colori in TUTTE le pagine giocatori
 * (Pitch/Bench/Pool/Rosa/Rose/Catalogo).
 *
 *   Por                 — GIALLO  (warning)
 *   Dc/Dd/Ds/B          — VERDE   (success)
 *   E/M/C               — AZZURRO (info) — Andrea 2026-08-26: E come i centrocampisti
 *   W/T                 — VIOLA   (purple)
 *   A/Pc                — ROSSO   (danger)
 *
 * Per ruoli compositi "X/Y" (es. "Dc/B", "T/A"), il colore segue il
 * primo ruolo della coppia (cfr. helper `ruoloMantraClass`).
 */

export const RUOLO_MANTRA_COLOR: Record<string, string> = {
  // Portiere
  Por: "bg-warning text-ink border border-warning/60",
  // Difensori + esterni difensivi
  Dc: "bg-success text-ink border border-success/60",
  Dd: "bg-success text-ink border border-success/60",
  Ds: "bg-success text-ink border border-success/60",
  B: "bg-success text-ink border border-success/60",
  // Centrocampo (E incluso — stesso azzurro dei centrocampisti)
  E: "bg-info text-ink border border-info/60",
  M: "bg-info text-ink border border-info/60",
  C: "bg-info text-ink border border-info/60",
  // Esterni offensivi / Trequartisti
  W: "bg-purple text-white border border-purple/60",
  T: "bg-purple text-white border border-purple/60",
  // Attacco
  A: "bg-danger text-white border border-danger/60",
  Pc: "bg-danger text-white border border-danger/60",
};

/** Lista canonica dei ruoli Mantra in ordine logico portiere → attacco. */
export const RUOLI_MANTRA_ORDER = [
  "Por",
  "Dc",
  "Dd",
  "Ds",
  "B",
  "E",
  "M",
  "C",
  "W",
  "T",
  "A",
  "Pc",
] as const;

export type RuoloMantra = (typeof RUOLI_MANTRA_ORDER)[number];

/** Helper per renderizzare la classe colore con fallback.
 *  Gestisce ruoli compositi "X/Y": ritorna il colore del PRIMO ruolo.
 *  Esempi:
 *    ruoloMantraClass("Dc/B")  → bianco (Dc)
 *    ruoloMantraClass("M/C")   → blu (M)
 *    ruoloMantraClass("W/A")   → rosa (W)
 *    ruoloMantraClass("A/Pc")  → rosso (A)
 *    ruoloMantraClass("T/A")   → rosa (T)
 */
export function ruoloMantraClass(r: string): string {
  if (!r) return "bg-fg-muted/30 text-fg border border-fg-muted/50";
  const primary = r.split("/")[0]; // "T/A" → "T"
  return (
    RUOLO_MANTRA_COLOR[primary] ??
    "bg-fg-muted/30 text-fg border border-fg-muted/50"
  );
}
